export class DBOfflineStore<T> {
  constructor(
    public readonly name: string,
    public readonly storeParameters: IDBObjectStoreParameters = { autoIncrement: true },
    public readonly indexes: { name: string, keyPath: string | string[], options: IDBIndexParameters | undefined }[] = [],
  ) {}
}